// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5eb9eb84","239":"c3ad210c","453":"dc132d0c","667":"9f993001"}[chunkId] + ".chunk.js";
};